import { Component, Input, SimpleChange } from '@angular/core';
import { Router, NavigationEnd, EventType } from '@angular/router';
import * as _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { CustomSteps, CustomTabs, CustomTabsOptions } from '../custom-tabs/custom-tabs';
import { CustomStepsOptions, Step } from './custom-steps';
import { GlobalService } from 'src/app/services/global.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-custom-steps',
    templateUrl: './custom-steps.component.html',
    styleUrls: ['./custom-steps.component.scss'],
    animations: [
        trigger('slideDownUp', [
            transition(':enter', [
                style({ overflow: 'hidden', height: '0', opacity: 0 }),
                animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '*', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ overflow: 'hidden', height: '*', opacity: 1 }),
                animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', height: '0', opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class CustomStepsComponent {

  @Input() fields!: Array<CustomSteps>;
  @Input() options: CustomTabsOptions | undefined;

  
  active: string = /[^/;]+(?=;|$)/.exec(this.router.url)![0];
  activeNumber: number = 1;
  selected: number = 1;

  parsedFields: Array<CustomTabs> = [];

  isMobile: boolean = false;
  showList: boolean = false;


  // unsubscribe subscriptions
  private theEnd$: Subject<void> = new Subject<void>();  

  constructor(
    private router: Router, private globalS: GlobalService
  ) {
    //this.parsedFields = this.fields;    
  }  


  ngOnInit(): void {
    this.activateTab();    
    this.router.events.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (event: any) => {
        if(event instanceof NavigationEnd) {
          // to the thinghs to set tab active based on url
          this.setActiveState(event);
        }
      }
    });  

    this.isMobile = this.globalS.isMobile();

    this.globalS.isMobile$.pipe(takeUntil(this.theEnd$)).subscribe(isMobile=>{
      this.isMobile = isMobile;
    })
  }

  /**
   * Change the active tab based on last part of the url
   * @param event NavigationStart: data from router 
   */
  setActiveState(event: NavigationEnd) {
    console.warn(event);
    // get the last part from url
    var result = /[^/;]+(?=;|$)/.exec(event.url)![0];
    //console.error(result);
    // check if the last part is in the array
    let i = this.fields.find(x => x.routerOutlet.includes(result));
    // is it?
    console.log("in set active");
    console.log(i);
    if(i != undefined) {
      // if it is give the active status to the required field
      console.log("its includded");
      this.active = i.routerOutlet;      

      if(i.number >= this.activeNumber) {
        this.activeNumber = i.number;
      }

      this.selected = i.number;
      //console.error(this.active);
    }
  }

  /**
   * Disable all the tabs that need to be disabled
   */
  disableTabs(): void {    
    setTimeout(() => {
      for(let i = 0; i < this.fields.length; i++) {                        
        let t = document.getElementById(this.fields[i].title) as HTMLButtonElement;
        //console.log(t);
        if(t != null) {
          if(this.fields[i]!.disabled == true) {
            t!.disabled = true;      
          }else{
            t!.disabled = false;
          }      
        }        
      }  
    }, 10);    
  }

  /**
   * Redirect to active tab
   */
  activateTab() {
    var res = this.fields.find(x => x.active == true);
    var result = /[^/]*$/.exec(this.router.url)![0];
    console.log(res);
    console.log(result);
    if(res != undefined) {      
      if(res.routerOutlet != result) {
        this.router.navigate([`${this.router.url}/${res.routerOutlet}`, res.routerParams]);
      }    
    }else{
      // better do nothing 
      /*if(this.fields[0].routerOutlet != result) {
        this.router.navigate([`${this.router.url}/${this.fields[0].routerOutlet}`]);
      }*/
    }
  }

  /**
   * Return the correct background for the tab
   */
  getTabBackground(tab: CustomTabs): string {
    // if not active dont need to show color
    if(tab.routerOutlet == this.active) {
      if(tab.background == undefined || null) {      
        if(this.options?.background != undefined || this.options?.background !=  null ) {
          // color for all tabs is setted        
          return this.options.background;
        }else{
          // return default color
          return 'var(--color-primary-400)';
        }
      // tab background is setted
      }else {
        return tab.background;
      }
    }else {
      return 'rgba(255,255,255,0.0)';
    }  
  }

  /**
   * return the correct color for the tab
   */
  getTabColor(tab: CustomTabs): string {
    // if not active dont need to show color
    if(tab.routerOutlet == this.active) {
      if(tab.color == undefined || null) {      
        if(this.options?.color != undefined || this.options?.color !=  null ) {
          // color for all tabs is setted        
          return this.options.color;
        }else{
          if(tab.disabled == true) {
            return 'var(--color-primary-disabled)';
          }
          // return default color
          return '#ffffff';
        }
      // tab background is setted
      }else {
        return tab.color;
      }
    }else {
      if(tab.disabled == true) {
        return 'var(--color-primary-disabled)';
      }
      return '#000000';
    }  
  }

  ngAfterViewInit(): void {
    let event: NavigationEnd = {
      id:0,            
      url: this.router.url,
      type: EventType.NavigationEnd,
      urlAfterRedirects: '',
    };
    // activate tabs
    this.setActiveState(event);
    // disable the tabs
    this.disableTabs();      
    // set hover
    this.changeTabsHoverColor(this.fields);
  }

  changeTabsHoverColor(tabs: CustomTabs[]) {
    for(let i = 0; i < tabs.length; i++) {
      const tab = document.getElementById(tabs[i].title) as HTMLButtonElement;
      if(tab != undefined || null) {
        tab.style.setProperty('--tabs-bg-hover-color', tabs[i].background || this.options?.background || 'var(--color-primary-400)');
        tab.style.setProperty('--tabs-text-hover-color', '#ffffff');
      }
    }  
  }

  ngOnChanges(changes: {fields: SimpleChange}): void {
    if(changes.fields) {
      this.parseField(changes.fields.currentValue);
      this.disableTabs();
      let event: NavigationEnd = {
        id:0,            
        url: this.router.url,
        type: EventType.NavigationEnd,
        urlAfterRedirects: '',
      };
      this.setActiveState(event);
      this.changeTabsHoverColor(changes.fields.currentValue);
    }
  }

  ngOnDestroy(): void {
        this.theEnd$.next();
    this.theEnd$.complete();
  }

  parseField(fields: Array<CustomTabs>) {
    this.parsedFields = _.cloneDeep(fields);
  }

}
